
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import { useState } from "react";

export default function WhatsAppButton() {
    const [showMessage, setShowMessage] = useState(false);

    const phoneNumber = "971502477593";

    const message = encodeURIComponent(
        "Hello, I would like to know more about your hotel deals."
    );

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[9999]">

            {/* WhatsApp Message Popup */}
            <div
                id="whatsapp-popup"
                aria-hidden={!showMessage}
                className={`
          absolute right-0 bottom-[72px]
          w-[260px]
          bg-white
          rounded-2xl
          shadow-[0_15px_40px_rgba(15,23,42,0.18)]
          border border-slate-100
          p-4
          transition-all duration-300
          origin-bottom-right
          ${showMessage
                        ? "opacity-100 scale-100 translate-y-0"
                        : "opacity-0 scale-95 translate-y-2 pointer-events-none"
                    }
        `}
            >
                {/* Accessible Close Button */}
                <button
                    type="button"
                    onClick={() => setShowMessage(false)}
                    aria-label="Close WhatsApp message"
                    title="Close"
                    tabIndex={showMessage ? 0 : -1}
                    className="
            absolute top-3 right-3
            text-slate-400
            hover:text-slate-700
            focus-visible:outline
            focus-visible:outline-2
            focus-visible:outline-offset-2
            focus-visible:outline-[#168B43]
            transition-colors
          "
                >
                    <FaTimes size={12} aria-hidden="true" />
                </button>

                <div className="flex items-center gap-3">
                    <div
                        className="
              w-10 h-10 rounded-xl
              bg-[#25D366]/10
              flex items-center justify-center
              shrink-0
            "
                    >
                        <FaWhatsapp
                            aria-hidden="true"
                            className="text-[#25D366] text-xl"
                        />
                    </div>

                    <div>
                        <p className="font-bold text-slate-900 text-sm">
                            Need Help?
                        </p>

                        <p className="text-xs text-slate-500 mt-1">
                            Chat with our travel team
                        </p>
                    </div>
                </div>

                {/* WhatsApp Link */}
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat with our travel team on WhatsApp (opens in a new tab)"
                    tabIndex={showMessage ? 0 : -1}
                    className="
            mt-4 w-full
            flex items-center justify-center gap-2
            bg-[#25D366]
            hover:bg-[#20bd5a]
            text-white
            py-2.5
            rounded-xl
            text-sm
            font-semibold
            transition
            focus-visible:outline
            focus-visible:outline-2
            focus-visible:outline-offset-2
            focus-visible:outline-[#168B43]
          "
                >
                    <FaWhatsapp aria-hidden="true" />
                    Chat on WhatsApp
                </a>
            </div>

            {/* Floating WhatsApp Button */}
            <div className="relative">
                {/* Decorative Pulse */}
                <span
                    aria-hidden="true"
                    className="
            absolute inset-0
            rounded-full
            bg-[#25D366]
            animate-ping
            opacity-20
            pointer-events-none
          "
                />

                <button
                    type="button"
                    onClick={() => setShowMessage((prev) => !prev)}
                    aria-label={
                        showMessage
                            ? "Close WhatsApp chat options"
                            : "Open WhatsApp chat options"
                    }
                    aria-expanded={showMessage}
                    aria-controls="whatsapp-popup"
                    title="WhatsApp Support"
                    className="
            relative
            w-14 h-14
            sm:w-16 sm:h-16
            rounded-full
            bg-[#25D366]
            text-white
            flex items-center justify-center
            shadow-[0_10px_30px_rgba(37,211,102,0.35)]
            hover:scale-110
            hover:shadow-[0_15px_35px_rgba(37,211,102,0.45)]
            transition-all duration-300
            focus-visible:outline
            focus-visible:outline-2
            focus-visible:outline-offset-4
            focus-visible:outline-[#168B43]
          "
                >
                    <FaWhatsapp
                        aria-hidden="true"
                        className="text-3xl sm:text-[34px]"
                    />
                </button>
            </div>
        </div>
    );
}
